<template>
  <span class="tooltip" :class="{ [autoPosition]: true }" @click="showTip()">
    <span :class="link ? 'link text-underline' : ''">{{ content }}</span>
    <hardword-reactive
      :value="tip"
      v-show="showTipEvent && show"
      class="tooltip-text vue-popover dropdown-position-top"
    >
      {{ tip }}
    </hardword-reactive>
  </span>
</template>

<script>
const { $ } = window;
import HardwordReactive from "@/desktop/views/mv/components/HardwordReactive";
export default {
  components: { HardwordReactive },
  props: {
    position: {
      type: String,
      default: "top",
      validator(value) {
        return ["top", "bottom", "left", "right"].includes(value);
      },
    },
    content: {
      type: String,
      require: true,
    },
    tip: {
      type: String,
    },
    link: {
      type: Boolean,
      default: true,
    },
    showTipEvent: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    switcher() {
      if (this.show) {
        this.show = false;
        setTimeout(() => document.removeEventListener("click", this.switcher));
      }
    },
    showTip() {
      this.show = true;
      setTimeout(() => document.addEventListener("click", this.switcher));
    },
  },
  computed: {
    autoPosition() {
      const $el = $(this.$el);
      if (this.position === "top" && $el.length && $el.position().top < 0) {
        return "bottom";
      }
      return this.position;
    },
  },
  mounted() {
    this.$once("hook:destroyed", () =>
      document.removeEventListener("click", this.switcher)
    );
  },
};
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltip-text {
  width: 300px;
  background-color: #fff;
  color: black;
  text-align: left;
  border-radius: 6px;
  position: absolute;
  z-index: 10;
  transition: opacity 0.3s;
  font-family: Arial, Helvetica, sans-serif;
  padding: 20px;
  border: 1px solid #c2c4c7;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
/* Tooltip top content */
.top .tooltip-text {
  bottom: 100%;
  left: 50%;
  margin-left: -140px; /* 120/2 = 60 */
}
/* Tooltip right content */
.right .tooltip-text {
  top: -5px;
  left: 110%;
}
/* Tooltip bottom content */
.bottom .tooltip-text {
  top: 100%;
  left: 50%;
  margin-left: -140px; /* 120/2 = 60 */
}
/* Tooltip left content */
.left .tooltip-text {
  top: -5px;
  right: 110%;
}
.right-bottom .tooltip-text {
  top: 125%;
  right: 0%;
}
.tooltip .tooltip-text::after {
  content: "";
  position: absolute;
}
.vue-popover .dropdown-position-top:before {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  top: -6px;
  left: calc(97% - 30px);
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
.vue-popover .dropdown-position-top:after {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid rgb(78, 78, 78);
  border-top: 0px solid #c2c4c7;
  top: -6px;
  bottom: auto;
  left: calc(97% - 30px);
  filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
}
</style>
